import { DAILY_LOG_KEY_PREFIX } from 'functions/constants/miscContants'

export const getIsDailyLogId = (id: string | undefined | null) => {
  return id && id.includes(DAILY_LOG_KEY_PREFIX)
}
